import type { FaireProductEntity } from "../../entity_types/product";

export const p_m233jwjj5m: FaireProductEntity = {
  token: "p_m233jwjj5m",
  type: "product",
  name: "dahlia bouquet notecard",
  brandToken: "b_mmdanrh9jf",
  brandName: "emily lex studio",
  imageUrl:
    "https://cdn.faire.com/fastly/d0d8c184a5e46749c755475daea1feb55fc0390bb56d47e0d98edbe93acdae63.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/60d9d07e0e0ade45f2937940d8918064a7cf8eeabd62c0711be8ded5d94e7b9c.jpeg",
    "https://cdn.faire.com/fastly/deffa91b092a3c3da0418a4f931b880a99d0d7e055d971bcda262f0787f38d9e.jpeg",
  ],
  priceDollars: 8,
  description:
    "Send sweet greetings to your loved ones. These Dahlia Bouquet notecards are blank on the inside with a charming watercolor illustration of a bouquet on the front. They bring a touch of cozy cheer to your thank you notes, get well wishes, and more.\n\n• set of eight (or single) folded cards with envelopes\n• blank inside\n• 5.5 inch x 4.25 inch\n• printed on 120lb superfine paper\n• original artwork by Emily Lex",
  tags: [],
  msrpDollars: 16,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-14T07:14:48.871Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
